import React, { createContext, useContext, useEffect, useState } from 'react';
const LazyloadContext = /*#__PURE__*/createContext({});
export const useLazyload = lazyid => {
  const [states, setStates] = useContext(LazyloadContext);
  useEffect(() => {
    setStates(prev => ({ ...prev,
      [lazyid]: false
    }));
    return () => setStates(prev => {
      const newStates = { ...prev
      };
      delete newStates[lazyid];
      return newStates;
    });
  }, []);
  return states[lazyid] || false;
};

const LazyloadContainer = ({
  children
}) => {
  const provide = useState({});
  const [states, setStates] = provide;
  useEffect(() => {
    const htmlElement = document.documentElement;

    const handler = () => {
      const scrollLeft = htmlElement.scrollLeft;
      const scrollTop = htmlElement.scrollTop;
      const frameLeftEdge = window.innerWidth + scrollLeft;
      const frameTopEdge = window.innerHeight + scrollTop;
      const lazyElements = document.querySelectorAll('[data-lazyid][data-lazyloaded="false"]');

      if (lazyElements.length > 0) {
        const elementsToLoad = Array.from(lazyElements).filter(lazyElement => {
          const coordinate = lazyElement.getBoundingClientRect();
          const elementTop = scrollTop + coordinate.y;
          const elementLeft = scrollLeft + coordinate.x;
          return frameTopEdge > elementTop && frameLeftEdge > elementLeft && !!lazyElement.getAttribute('data-lazyid');
        }); // .reduce

        if (elementsToLoad.length > 0) {
          const data = elementsToLoad.reduce((result, each, index) => {
            result[each.getAttribute('data-lazyid')] = true;
            return result;
          }, {});
          setStates(prev => ({ ...prev,
            ...data
          }));
        }
      }
    };

    handler();
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, [states]);
  return /*#__PURE__*/React.createElement(LazyloadContext.Provider, {
    value: provide
  }, children);
};

export default LazyloadContainer;